import { Button, type ButtonProps } from 'antd'

import cn from '@/utils/tailwind/cn'

export const IntegrationCardButton = ({ className, ...props }: ButtonProps) => (
  <Button
    className={cn(
      'h-[30px] !px-3 !text-xs [&.ant-btn-dangerous]:!border [&.ant-btn-dangerous]:!border-red-600 [&.ant-btn-dangerous]:!bg-transparent [&.ant-btn-dangerous]:!text-red-600 [&.ant-btn-dangerous]:!outline-red-700 [&.ant-btn-dangerous]:hover:!bg-red-600/10 [&.ant-btn-link]:!border-blue-600 [&.ant-btn-link]:hover:!border-blue-600/60',
      className
    )}
    type="primary"
    {...props}
  />
)
